import React from "react";
import {
  TimelineContainer,
  TimelineRow,
  TimelineSeparatorColumn,
  TimelinePreConnector,
  TimelinePostConnector,
  TimelineDotSlot,
  TimelineItemContent,
} from "./ChatTimeline.styles";

export type ChatTimelineItem = {
  key: string;
  dot: React.ReactNode;
  content: React.ReactNode;
};

type Props = {
  items: ChatTimelineItem[];
};

export const ChatTimeline = ({ items }: Props) => (
  <TimelineContainer role="list">
    {items.map((item, index) => {
      const isFirst = index === 0;
      const isLast = index === items.length - 1;
      return (
        <TimelineRow key={item.key} role="listitem">
          <TimelineSeparatorColumn aria-hidden="true">
            <TimelinePreConnector $visible={!isFirst} />
            <TimelineDotSlot>{item.dot}</TimelineDotSlot>
            <TimelinePostConnector $visible={!isLast} />
          </TimelineSeparatorColumn>
          {item.content != null && (
            <TimelineItemContent>{item.content}</TimelineItemContent>
          )}
        </TimelineRow>
      );
    })}
  </TimelineContainer>
);
